import httpClient from '@/httpClient';
import { fileService } from './fileService';
import i18n from '@/languages/i18n';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { try2GetErrorMessage } from '@/helpers/errorHandle';

class ExportService {
  _handleApiDownloadPromise = (apiPromise: Promise<any>) => {
    apiPromise
      .then(res => {
        fileService.saveByte2File(fileService.getFileName(res.headers), res.data);
      })
      .catch(err => {
        try {
          ModalUtils.error({
            title: 'Error',
            content: i18n.t(try2GetErrorMessage(err)),
          });
        } catch (error) {
          ModalUtils.error({
            title: 'Error',
            content: i18n.t(UNKNOWN_ERROR_MESSAGE),
          });
        }
      })
      .finally(() => {});
  };
  exportBookingPdf = (bookingId: string) => {
    this._handleApiDownloadPromise(
      httpClient.post(
        `/agent-portal/bookings/download-booking-pdf/${bookingId}`,
        {},
        {
          responseType: 'arraybuffer',
        },
      ),
    );
  };
  downloadOrderReceipt = (orderId: string) => {
    this._handleApiDownloadPromise(
      httpClient.post(
        `/agent-portal/bookings/download-order-receipt-pdf/${orderId}`,
        {},
        {
          responseType: 'arraybuffer',
        },
      ),
    );
  };
  exportBookings2Csv = params => {
    this._handleApiDownloadPromise(httpClient.post(`/agent-portal/bookings/export-booking-report`, null, { params: params, responseType: 'blob' }));
  };
}

export const exportService = new ExportService();
